import { lazy } from "react";
import { PATH } from "../constants/paths";

const PAGE_404 = lazy(() => import("../components/404"));

const Dashboard_CM = lazy(() => import("../pages/Dashboard-CM"));
const AdminDashboard = lazy(() => import("../pages/Dashboard-ADMIN"));
const TS = lazy(() => import("../pages/Test-Series/TestSeries"));
const ADD_TS = lazy(() => import("../pages/Test-Series/Add"));
const ADD_TS_IMAGES = lazy(() => import("../pages/Test-Series/AddImages"));
const SERIES_VIEW = lazy(() => import("../pages/Test-Series/View"));
const SERIES_EDIT = lazy(() => import("../pages/Test-Series/Edit"));
const ADD_TEST = lazy(() => import("../pages/Exam/Add"));
const TESTS = lazy(() => import("../pages/Exam/TestsList"));
const TEST_VIEW = lazy(() => import("../pages/Exam/QuestionMapping"));
const TEST_EDIT = lazy(() => import("../pages/Exam/Edit"));

const SC_LIST = lazy(() => import("../pages/StaticContent/List"));
const SC_ADD = lazy(() => import("../pages/StaticContent/Add"));
const SC_VIEW = lazy(() => import("../pages/StaticContent/View"));
const SC_EDIT = lazy(() => import("../pages/StaticContent/Edit"));

const QUES_ADD = lazy(() => import("../pages/QuestionBank/Add"));
const QUES_ADD_VARIENT = lazy(() =>
  import("../pages/QuestionBank/Add-Varient")
);
const QUES_BULK_ADD = lazy(() => import("../pages/QuestionBank/BulkAdd"));
const QUES_LIST = lazy(() => import("../pages/QuestionBank/List"));
const QUES_STATS = lazy(() => import("../pages/QuestionBank/Overview"));
const QUES_REVIEW = lazy(() => import("../pages/QuestionBank/ReviewWorkspace"));

const QUES_VIEW = lazy(() => import("../pages/QuestionBank/View"));
const QUES_EDIT = lazy(() => import("../pages/QuestionBank/Edit"));
const CONTENT_MANAGER_LIST = lazy(() =>
  import("../pages/Accounts/ContentManagers/List")
);
const CONTENT_MANAGER_VIEW = lazy(() =>
  import("../pages/Accounts/ContentManagers/View")
);
const PAYMENT_CLAIM_REQ = lazy(() => import("../pages/Payment/ClaimRequests"));
const STORIES = lazy(() => import("../pages/Stories/storyboard"));
const USERS_LIST = lazy(() => import("../pages/Accounts/Users/list"));
const USERS_VIEW = lazy(() => import("../pages/Accounts/Users/view"));
const EMPLOYEES_LIST = lazy(() => import("../pages/Accounts/Employees/List"));
const EMPLOYEES_VIEW = lazy(() => import("../pages/Accounts/Employees/Detail"));
const TICKET_VIEW = lazy(() =>
  import("../pages/Accounts/ContentManagers/TicketView")
);
const USERS_ORDER_VIEW = lazy(() =>
  import("../pages/Accounts/Users/orderDetails")
);
const LIST_ORDERS = lazy(() => import("../pages/Orders/list"));
const TEST_PREVIEW_CMS = lazy(() =>
  import("../pages/TestSeriesPreviewInternal/TestInstruction")
);
const EXAM_PORTAL = lazy(() =>
  import("../pages/TestSeriesPreviewInternal/ExamPortal/PortalMain")
);
const WORK_TASK_VIEW = lazy(() =>
  import("../pages/Accounts/ContentManagers/WorkTaskView")
);
const WORK_TASK_DETAILED_VIEW = lazy(() =>
  import("../pages/Accounts/ContentManagers/WorkTaskDetailedView")
);
const CLAIM_REQUEST_VIEW = lazy(() =>
  import("../pages/Accounts/ContentManagers/ClaimRequestView")
);
const CM_TASKS = lazy(() => import("../pages/CM-Panel/Tasks/Tasks"));
const CM_CLAIM_HISTORY = lazy(() =>
  import("../pages/CM-Panel/ClaimHistory/ClaimHistory")
);
const CM_CLAIM_HISTORY_VIEW = lazy(() =>
  import("../pages/CM-Panel/ClaimHistory/ClaimHistoryView")
);
const CM_FAQS_LIST = lazy(() => import("../pages/CM-Panel/FandQ/List"));
const CM_FAQ_ADD = lazy(() => import("../pages/CM-Panel/FandQ/Add"));
const CM_FAQ_VIEW = lazy(() => import("../pages/CM-Panel/FandQ/View"));
const CM_ADD_VALIDATE_TASK = lazy(() =>
  import("../pages/CM-Panel/Tasks/AddValidateTask")
);
const CONFIG_SYSTEMS = lazy(() => import("../pages/Systems/System"));
const CONFIG_DROPDOWNS = lazy(() => import("../pages/Systems/Dropdown"));
const CONFIG_TESTS = lazy(() => import("../pages/Systems/TestConfig"));
const CANVAS = lazy(() => import("../pages/Canvas"));
const EXAM_REVIEW = lazy(() => import("../pages/Report/Report"));
const EXAMS_NOTIFICATIONS_LIST = lazy(() =>
  import("../pages/Notifications/Exams/List")
);
const EXAMS_NOTIFICATIONS_VIEW = lazy(() =>
  import("../pages/Notifications/Exams/View")
);
const ENTITIES_LIST = lazy(() => import("../pages/Entities/List"));
const CONTROL_BOARD = lazy(() => import("../pages/ControlBoard/List"));
const ENTITY_FILL_DETAILS = lazy(() => import("../pages/Entities/FillDetails"));
const ENTITY_UPDATE_DETAILS = lazy(() =>
  import("../pages/Entities/UpdateDetails")
);
const ENTITY_VIEW_CONTENT = lazy(() => import("../pages/Entities/ViewContent"));
const LISTS_ENTITIES = lazy(() => import("../pages/Lists/Entities/List"));
const LISTS_EXAMS = lazy(() => import("../pages/Lists/Exams/List"));
const LISTS_MAPPINGS = lazy(() =>
  import("../pages/Lists/Mappings/Subjects/List")
);
const LISTS_MAPPINGS_ADD = lazy(() =>
  import("../pages/Lists/Mappings/Subjects/Add")
);
const LISTS_MAPPINGS_VIEW = lazy(() =>
  import("../pages/Lists/Mappings/Subjects/View")
);
const LISTS_MAPPINGS_EDIT = lazy(() =>
  import("../pages/Lists/Mappings/Subjects/Edit")
);
const COMPETITIONS_LIST = lazy(() => import("../pages/Competitions/List"));
const COMPETITION_ADD = lazy(() => import("../pages/Competitions/Add"));
const COMPETITION_VIEW = lazy(() => import("../pages/Competitions/View"));
const COMPETITION_EDIT = lazy(() => import("../pages/Competitions/Edit"));
const COMPETITION_PARTICIPANT = lazy(() =>
  import("../pages/Competitions/Participant")
);
const SM_LIST = lazy(() => import("../pages/StaticMaterial/List"));
const SM_ADD = lazy(() => import("../pages/StaticMaterial/Add"));
const SM_EDIT = lazy(() => import("../pages/StaticMaterial/Edit"));
const SM_VIEW = lazy(() => import("../pages/StaticMaterial/View"));
const WALLET_TRANSACTION = lazy(() =>
  import("../pages/Accounts/Users/transaction")
);
const OFFERS_LIST = lazy(() => import("../pages/Offers/List"));
const OFFER_ADD = lazy(() => import("../pages/Offers/Add"));
const OFFER_EDIT = lazy(() => import("../pages/Offers/Edit"));
const OFFER_VIEW = lazy(() => import("../pages/Offers/View"));
const CREDIT_MINT_LIST = lazy(() => import("../pages/CreditMint/List"));
const CREDIT_MINT_ADD = lazy(() => import("../pages/CreditMint/Add"));
const CREDIT_MINT_EDIT = lazy(() => import("../pages/CreditMint/Edit"));
const CREDIT_MINT_VIEW = lazy(() => import("../pages/CreditMint/View"));
const CREDIT_MINT_DROPS = lazy(() => import("../pages/CreditMint/Drops"));
const FAQS_LIST = lazy(() => import("../pages/FAQs/List"));
const FAQ_VIEW = lazy(() => import("../pages/FAQs/View"));
const ISSUES_LIST = lazy(() => import("../pages/Issues/List"));
const ISSUE_INTERNAL_VIEW = lazy(() => import("../pages/Issues/InternalView"));
const LISTS_SUBJECTS = lazy(() => import("../pages/Lists/Subjects/List"));
const LISTS_TOPICS = lazy(() => import("../pages/Lists/Topics/List"));
const USERS_NOTIFICATIONS = lazy(() =>
  import("../pages/Notifications/Users/List")
);
const CHAT_FORUMS = lazy(() => import("../pages/ChatForums/List"));
const CHAT_FORUM_DETAILS = lazy(() => import("../pages/ChatForums/Details"));
const DOWNLOADABLE_TESTS = lazy(() => import("../pages/DownloadableTests/List"));
const DOWNLOADABLE_TESTS_UPLOAD = lazy(() =>
  import("../pages/DownloadableTests/Upload")
);
const DOWNLOADABLE_TESTS_VIEW = lazy(() =>
  import("../pages/DownloadableTests/View")
);
const DOWNLOADABLE_TESTS_STRUCTURE = lazy(() =>
  import("../pages/DownloadableTests/Structure")
);
const PRACTICE_PAPERS = lazy(() => import("../pages/PracticePapers/List"));
const PRACTICE_PAPERS_FORM = lazy(() => import("../pages/PracticePapers/Form"));
const PRACTICE_PAPERS_QUESTIONS = lazy(() =>
  import("../pages/PracticePapers/Questions")
);
const PRACTICE_PAPERS_METRICS = lazy(() =>
  import("../pages/PracticePapers/Metrics")
);
const MOCK_TEST_CREATOR_LIST = lazy(() => import("../pages/MockTestCreator/List"));
const MOCK_TEST_CREATOR_NEW = lazy(() => import("../pages/MockTestCreator/Wizard"));
const MOCK_TEST_CREATOR_REVIEW = lazy(() =>
  import("../pages/MockTestCreator/ReviewWorkspace")
);
const SETTINGS_CHANGE_PASSWORD = lazy(() => import("../pages/Settings/ChangePassword"));
const SETTINGS_TWO_FACTOR = lazy(() => import("../pages/Settings/TwoFactor"));
const PARTNERS_LIST = lazy(() => import("../pages/Partners/List"));
const PARTNERS_NEW = lazy(() => import("../pages/Partners/Onboard"));
const PARTNERS_DETAIL = lazy(() => import("../pages/Partners/Detail"));
const PARTNER_DASHBOARD = lazy(() => import("../pages/PartnerPortal/Dashboard"));
const PARTNER_MEMBERS = lazy(() => import("../pages/PartnerPortal/Members"));
const PARTNER_CREDITS = lazy(() => import("../pages/PartnerPortal/CreditHistory"));
const routes = [
  {
    path: PATH.ADMINDASH,
    key: PATH.ADMINDASH,
    isProtected: true,
    page: <AdminDashboard />,
  },
  {
    path: PATH.TS,
    key: PATH.TS,
    isProtected: true,
    page: <TS />,
  },
  {
    path: PATH.ADD_TS,
    key: PATH.ADD_TS,
    isProtected: true,
    page: <ADD_TS />,
  },
  {
    path: PATH.ADD_TS_IMAGES,
    key: PATH.ADD_TS_IMAGES,
    isProtected: true,
    page: <ADD_TS_IMAGES />,
  },
  {
    path: PATH.TEST_ADD,
    key: PATH.TEST_ADD,
    isProtected: true,
    page: <ADD_TEST />,
  },
  {
    path: PATH.TESTS,
    key: PATH.TESTS,
    isProtected: true,
    page: <TESTS />,
  },
  {
    path: PATH.QUES_ADD,
    key: PATH.QUES_ADD,
    isProtected: true,
    page: <QUES_ADD />,
  },
  {
    path: PATH.QUES_ADD_V,
    key: PATH.QUES_ADD_V,
    isProtected: true,
    page: <QUES_ADD_VARIENT />,
  },
  {
    path: PATH.QUES_LIST,
    key: PATH.QUES_LIST,
    isProtected: true,
    page: <QUES_LIST />,
  },
  {
    path: PATH.QUES_STATS,
    key: PATH.QUES_STATS,
    isProtected: true,
    page: <QUES_STATS />,
  },
  {
    path: PATH.QUES_BULK_ADD,
    key: PATH.QUES_BULK_ADD,
    isProtected: true,
    page: <QUES_BULK_ADD />,
  },
  {
    path: PATH.QUES_REVIEW,
    key: PATH.QUES_REVIEW,
    isProtected: true,
    page: <QUES_REVIEW />,
  },
  {
    path: PATH.QUES_VIEW,
    key: PATH.QUES_VIEW,
    isProtected: true,
    page: <QUES_VIEW />,
  },
  {
    path: PATH.QUES_VIEW_BASE,
    key: PATH.QUES_VIEW_BASE,
    isProtected: true,
    page: <QUES_VIEW />,
  },
  {
    path: PATH.QUES_EDIT,
    key: PATH.QUES_Edit,
    isProtected: true,
    page: <QUES_EDIT />,
  },
  {
    path: PATH.CONTENT_MANAGER_LIST,
    key: PATH.CONTENT_MANAGER_LIST,
    isProtected: true,
    page: <CONTENT_MANAGER_LIST />,
  },
  {
    path: PATH.CONTENT_MANAGER_VIEW,
    key: PATH.CONTENT_MANAGER_VIEW,
    isProtected: true,
    page: <CONTENT_MANAGER_VIEW />,
  },
  {
    path: PATH.PAYMENT_CLAIM_REQ,
    key: PATH.PAYMENT_CLAIM_REQ,
    isProtected: true,
    page: <PAYMENT_CLAIM_REQ />,
  },
  {
    path: PATH.Dashboard_CM,
    key: PATH.Dashboard_CM,
    isProtected: true,
    page: <Dashboard_CM />,
  },
  {
    path: PATH.TEST_VIEW,
    key: PATH.TEST_VIEW,
    isProtected: true,
    page: <TEST_VIEW />,
  },
  {
    path: PATH.TEST_EDIT,
    key: PATH.TEST_EDIT,
    isProtected: true,
    page: <TEST_EDIT />,
  },
  {
    path: PATH.SERIES_VIEW,
    key: PATH.SERIES_VIEW,
    isProtected: true,
    page: <SERIES_VIEW />,
  },
  {
    path: PATH.EDIT_TS,
    key: PATH.EDIT_TS,
    isProtected: true,
    page: <SERIES_EDIT />,
  },
  {
    path: PATH.STORIES,
    key: PATH.STORIES,
    isProtected: true,
    page: <STORIES />,
  },
  {
    path: PATH.USERS_LIST,
    key: PATH.USERS_LIST,
    isProtected: true,
    page: <USERS_LIST />,
  },
  {
    path: PATH.USERS_VIEW,
    key: PATH.USERS_VIEW,
    isProtected: true,
    page: <USERS_VIEW />,
  },
  {
    path: PATH.EMPLOYEES_LIST,
    key: PATH.EMPLOYEES_LIST,
    isProtected: true,
    page: <EMPLOYEES_LIST />,
  },
  {
    path: PATH.EMPLOYEES_VIEW,
    key: PATH.EMPLOYEES_VIEW,
    isProtected: true,
    page: <EMPLOYEES_VIEW />,
  },
  {
    path: PATH.TICKET_VIEW,
    key: PATH.TICKET_VIEW,
    isProtected: true,
    page: <TICKET_VIEW />,
  },
  {
    path: PATH.USERS_ORDER_VIEW,
    key: PATH.USERS_ORDER_VIEW,
    isProtected: true,
    page: <USERS_ORDER_VIEW />,
  },
  {
    path: PATH.ORDERS,
    key: PATH.ORDERS,
    isProtected: true,
    page: <LIST_ORDERS />,
  },
  {
    path: PATH.ORDERS,
    key: PATH.ORDERS,
    isProtected: true,
    page: <LIST_ORDERS />,
  },
  {
    path: PATH.TEST_PREVIEW,
    key: PATH.TEST_PREVIEW,
    isProtected: true,
    pageExternal: true,
    page: <TEST_PREVIEW_CMS />,
  },
  {
    path: PATH.RUN_TEST_PREVIEW,
    key: PATH.RUN_TEST_PREVIEW,
    isProtected: true,
    pageExternal: true,
    page: <EXAM_PORTAL />,
  },
  {
    path: localStorage.getItem("user_token") != null ? "*" : "/nopage",
    key: "none",
    isProtected: false,
    page: localStorage.getItem("user_token") != null ? <PAGE_404 /> : "",
  },
  {
    path: PATH.SC_LIST,
    key: PATH.SC_LIST,
    isProtected: true,
    page: <SC_LIST />,
  },
  {
    path: PATH.SC_ADD,
    key: PATH.SC_ADD,
    isProtected: true,
    page: <SC_ADD />,
  },
  {
    path: PATH.SC_VIEW,
    key: PATH.SC_VIEW,
    isProtected: true,
    page: <SC_VIEW />,
  },
  {
    path: PATH.SC_EDIT,
    key: PATH.SC_EDIT,
    isProtected: true,
    page: <SC_EDIT />,
  },
  {
    path: PATH.EXAM_REVIEW,
    key: PATH.EXAM_REVIEW,
    isProtected: true,
    pageExternal: true,
    page: <EXAM_REVIEW />,
  },
  {
    path: PATH.WORK_TASK_VIEW,
    key: PATH.WORK_TASK_VIEW,
    isProtected: true,
    page: <WORK_TASK_VIEW />,
  },
  {
    path: PATH.WORK_TASK_DETAILED_VIEW,
    key: PATH.WORK_TASK_DETAILED_VIEW,
    isProtected: true,
    pageExternal: true,
    page: <WORK_TASK_DETAILED_VIEW />,
  },
  {
    path: PATH.CLAIM_REQUEST_VIEW,
    key: PATH.CLAIM_REQUEST_VIEW,
    isProtected: true,
    page: <CLAIM_REQUEST_VIEW />,
  },
  {
    path: PATH.CM_TASKS,
    key: PATH.CM_TASKS,
    isProtected: true,
    page: <CM_TASKS />,
  },
  {
    path: PATH.CM_CLAIM_HISTORY,
    key: PATH.CM_CLAIM_HISTORY,
    isProtected: true,
    page: <CM_CLAIM_HISTORY />,
  },
  {
    path: PATH.CM_CLAIM_HISTORY_VIEW,
    key: PATH.CM_CLAIM_HISTORY_VIEW,
    isProtected: true,
    page: <CM_CLAIM_HISTORY_VIEW />,
  },
  {
    path: PATH.CM_FAQS_LIST,
    key: PATH.CM_FAQS_LIST,
    isProtected: true,
    page: <CM_FAQS_LIST />,
  },
  {
    path: PATH.CM_FAQ_ADD,
    key: PATH.CM_FAQ_ADD,
    isProtected: true,
    page: <CM_FAQ_ADD />,
  },
  {
    path: PATH.CM_FAQ_VIEW,
    key: PATH.CM_FAQ_VIEW,
    isProtected: true,
    page: <CM_FAQ_VIEW />,
  },
  {
    path: PATH.CM_ADD_VALIDATE_TASK,
    key: PATH.CM_ADD_VALIDATE_TASK,
    isProtected: true,
    pageExternal: true,
    page: <CM_ADD_VALIDATE_TASK />,
  },
  {
    path: PATH.CONFIG_SYSTEMS,
    key: PATH.CONFIG_SYSTEMS,
    isProtected: true,
    page: <CONFIG_SYSTEMS />,
  },
  {
    path: PATH.CONFIG_DROPDOWNS,
    key: PATH.CONFIG_DROPDOWNS,
    isProtected: true,
    page: <CONFIG_DROPDOWNS />,
  },
  {
    path: PATH.CONFIG_TESTS,
    key: PATH.CONFIG_TESTS,
    isProtected: true,
    page: <CONFIG_TESTS />,
  },
  {
    path: PATH.CANVAS,
    key: PATH.CANVAS,
    isProtected: true,
    pageExternal: true,
    page: <CANVAS />,
  },
  {
    path: PATH.EXAMS_NOTIFICATIONS_LIST,
    key: PATH.EXAMS_NOTIFICATIONS_LIST,
    isProtected: true,
    page: <EXAMS_NOTIFICATIONS_LIST />,
  },
  {
    path: PATH.EXAMS_NOTIFICATIONS_VIEW,
    key: PATH.EXAMS_NOTIFICATIONS_VIEW,
    isProtected: true,
    page: <EXAMS_NOTIFICATIONS_VIEW />,
  },
  {
    path: PATH.CONTROL_BOARD,
    key: PATH.CONTROL_BOARD,
    isProtected: true,
    page: <CONTROL_BOARD />,
  },
  {
    path: PATH.ENTITIES_LIST,
    key: PATH.ENTITIES_LIST,
    isProtected: true,
    page: <ENTITIES_LIST />,
  },
  {
    path: PATH.ENTITY_FILL_DETAILS,
    key: PATH.ENTITY_FILL_DETAILS,
    isProtected: true,
    page: <ENTITY_FILL_DETAILS />,
  },
  {
    path: PATH.ENTITY_UPDATE_DETAILS,
    key: PATH.ENTITY_UPDATE_DETAILS,
    isProtected: true,
    page: <ENTITY_UPDATE_DETAILS />,
  },
  {
    path: PATH.ENTITY_VIEW_CONTENT,
    key: PATH.ENTITY_VIEW_CONTENT,
    isProtected: true,
    page: <ENTITY_VIEW_CONTENT />,
  },
  {
    path: PATH.LISTS_ENTITIES,
    key: PATH.LISTS_ENTITIES,
    isProtected: true,
    page: <LISTS_ENTITIES />,
  },
  {
    path: PATH.LISTS_EXAMS,
    key: PATH.LISTS_EXAMS,
    isProtected: true,
    page: <LISTS_EXAMS />,
  },
  {
    path: PATH.LISTS_MAPPINGS,
    key: PATH.LISTS_MAPPINGS,
    isProtected: true,
    page: <LISTS_MAPPINGS />,
  },
  {
    path: PATH.LISTS_MAPPINGS_ADD,
    key: PATH.LISTS_MAPPINGS_ADD,
    isProtected: true,
    page: <LISTS_MAPPINGS_ADD />,
  },
  {
    path: PATH.LISTS_MAPPINGS_VIEW,
    key: PATH.LISTS_MAPPINGS_VIEW,
    isProtected: true,
    page: <LISTS_MAPPINGS_VIEW />,
  },
  {
    path: PATH.LISTS_MAPPINGS_EDIT,
    key: PATH.LISTS_MAPPINGS_EDIT,
    isProtected: true,
    page: <LISTS_MAPPINGS_EDIT />,
  },
  {
    path: PATH.COMPETITIONS_LIST,
    key: PATH.COMPETITIONS_LIST,
    isProtected: true,
    page: <COMPETITIONS_LIST />,
  },
  {
    path: PATH.COMPETITION_ADD,
    key: PATH.COMPETITION_ADD,
    isProtected: true,
    page: <COMPETITION_ADD />,
  },
  {
    path: PATH.COMPETITION_VIEW,
    key: PATH.COMPETITION_VIEW,
    isProtected: true,
    page: <COMPETITION_VIEW />,
  },
  {
    path: PATH.COMPETITION_EDIT,
    key: PATH.COMPETITION_EDIT,
    isProtected: true,
    page: <COMPETITION_EDIT />,
  },
  {
    path: PATH.COMPETITION_PARTICIPANT,
    key: PATH.COMPETITION_PARTICIPANT,
    isProtected: true,
    page: <COMPETITION_PARTICIPANT />,
  },
  {
    path: PATH.SM_LIST,
    key: PATH.SM_LIST,
    isProtected: true,
    page: <SM_LIST />,
  },
  {
    path: PATH.SM_ADD,
    key: PATH.SM_ADD,
    isProtected: true,
    page: <SM_ADD />,
  },
  {
    path: PATH.SM_EDIT,
    key: PATH.SM_EDIT,
    isProtected: true,
    page: <SM_EDIT />,
  },
  {
    path: PATH.SM_VIEW,
    key: PATH.SM_VIEW,
    isProtected: true,
    page: <SM_VIEW />,
  },
  {
    path: PATH.WALLET_TRANSACTION,
    key: PATH.WALLET_TRANSACTION,
    isProtected: true,
    page: <WALLET_TRANSACTION />,
  },
  {
    path: PATH.OFFERS_LIST,
    key: PATH.OFFERS_LIST,
    isProtected: true,
    page: <OFFERS_LIST />,
  },
  {
    path: PATH.OFFER_ADD,
    key: PATH.OFFER_ADD,
    isProtected: true,
    page: <OFFER_ADD />,
  },
  {
    path: PATH.OFFER_EDIT,
    key: PATH.OFFER_EDIT,
    isProtected: true,
    page: <OFFER_EDIT />,
  },
  {
    path: PATH.OFFER_VIEW,
    key: PATH.OFFER_VIEW,
    isProtected: true,
    page: <OFFER_VIEW />,
  },
  {
    path: PATH.CREDIT_MINT_LIST,
    key: PATH.CREDIT_MINT_LIST,
    isProtected: true,
    page: <CREDIT_MINT_LIST />,
  },
  {
    path: PATH.CREDIT_MINT_ADD,
    key: PATH.CREDIT_MINT_ADD,
    isProtected: true,
    page: <CREDIT_MINT_ADD />,
  },
  {
    path: PATH.CREDIT_MINT_EDIT,
    key: PATH.CREDIT_MINT_EDIT,
    isProtected: true,
    page: <CREDIT_MINT_EDIT />,
  },
  {
    path: PATH.CREDIT_MINT_VIEW,
    key: PATH.CREDIT_MINT_VIEW,
    isProtected: true,
    page: <CREDIT_MINT_VIEW />,
  },
  {
    path: PATH.CREDIT_MINT_DROPS,
    key: PATH.CREDIT_MINT_DROPS,
    isProtected: true,
    page: <CREDIT_MINT_DROPS />,
  },
  {
    path: PATH.FAQS_LIST,
    key: PATH.FAQS_LIST,
    isProtected: true,
    page: <FAQS_LIST />,
  },
  {
    path: PATH.FAQ_VIEW,
    key: PATH.FAQ_VIEW,
    isProtected: true,
    page: <FAQ_VIEW />,
  },
  {
    path: PATH.ISSUES_LIST,
    key: PATH.ISSUES_LIST,
    isProtected: true,
    page: <ISSUES_LIST />,
  },
  {
    path: PATH.ISSUE_INTERNAL_VIEW,
    key: PATH.ISSUE_INTERNAL_VIEW,
    isProtected: true,
    page: <ISSUE_INTERNAL_VIEW />,
  },
  {
    path: PATH.LISTS_SUBJECTS,
    key: PATH.LISTS_SUBJECTS,
    isProtected: true,
    page: <LISTS_SUBJECTS />,
  },
  {
    path: PATH.LISTS_TOPICS,
    key: PATH.LISTS_TOPICS,
    isProtected: true,
    page: <LISTS_TOPICS />,
  },
  {
    path: PATH.USERS_NOTIFICATIONS,
    key: PATH.USERS_NOTIFICATIONS,
    isProtected: true,
    page: <USERS_NOTIFICATIONS />,
  },
  {
    path: PATH.CHAT_FORUMS,
    key: PATH.CHAT_FORUMS,
    isProtected: true,
    page: <CHAT_FORUMS />,
  },
  {
    path: PATH.CHAT_FORUM_DETAILS,
    key: PATH.CHAT_FORUM_DETAILS,
    isProtected: true,
    page: <CHAT_FORUM_DETAILS />,
  },
  {
    path: PATH.DOWNLOADABLE_TESTS,
    key: PATH.DOWNLOADABLE_TESTS,
    isProtected: true,
    page: <DOWNLOADABLE_TESTS />,
  },
  {
    path: PATH.DOWNLOADABLE_TESTS_UPLOAD,
    key: PATH.DOWNLOADABLE_TESTS_UPLOAD,
    isProtected: true,
    page: <DOWNLOADABLE_TESTS_UPLOAD />,
  },
  {
    path: PATH.DOWNLOADABLE_TESTS_VIEW,
    key: PATH.DOWNLOADABLE_TESTS_VIEW,
    isProtected: true,
    page: <DOWNLOADABLE_TESTS_VIEW />,
  },
  {
    path: PATH.DOWNLOADABLE_TESTS_STRUCTURE,
    key: PATH.DOWNLOADABLE_TESTS_STRUCTURE,
    isProtected: true,
    page: <DOWNLOADABLE_TESTS_STRUCTURE />,
  },
  {
    path: PATH.PRACTICE_PAPERS,
    key: PATH.PRACTICE_PAPERS,
    isProtected: true,
    page: <PRACTICE_PAPERS />,
  },
  {
    path: PATH.PRACTICE_PAPERS_ADD,
    key: PATH.PRACTICE_PAPERS_ADD,
    isProtected: true,
    page: <PRACTICE_PAPERS_FORM />,
  },
  {
    path: PATH.PRACTICE_PAPERS_EDIT,
    key: PATH.PRACTICE_PAPERS_EDIT,
    isProtected: true,
    page: <PRACTICE_PAPERS_FORM />,
  },
  {
    path: PATH.PRACTICE_PAPERS_QUESTIONS,
    key: PATH.PRACTICE_PAPERS_QUESTIONS,
    isProtected: true,
    page: <PRACTICE_PAPERS_QUESTIONS />,
  },
  {
    path: PATH.PRACTICE_PAPERS_METRICS,
    key: PATH.PRACTICE_PAPERS_METRICS,
    isProtected: true,
    page: <PRACTICE_PAPERS_METRICS />,
  },
  {
    path: PATH.MOCK_TEST_CREATOR_LIST,
    key: PATH.MOCK_TEST_CREATOR_LIST,
    isProtected: true,
    page: <MOCK_TEST_CREATOR_LIST />,
  },
  {
    path: PATH.MOCK_TEST_CREATOR_NEW,
    key: PATH.MOCK_TEST_CREATOR_NEW,
    isProtected: true,
    page: <MOCK_TEST_CREATOR_NEW />,
  },
  {
    path: PATH.MOCK_TEST_CREATOR_REVIEW,
    key: PATH.MOCK_TEST_CREATOR_REVIEW,
    isProtected: true,
    page: <MOCK_TEST_CREATOR_REVIEW />,
  },
  {
    path: PATH.SETTINGS_CHANGE_PASSWORD,
    key: PATH.SETTINGS_CHANGE_PASSWORD,
    isProtected: true,
    page: <SETTINGS_CHANGE_PASSWORD />,
  },
  {
    path: PATH.SETTINGS_TWO_FACTOR,
    key: PATH.SETTINGS_TWO_FACTOR,
    isProtected: true,
    page: <SETTINGS_TWO_FACTOR />,
  },
  {
    path: PATH.PARTNERS,
    key: PATH.PARTNERS,
    isProtected: true,
    page: <PARTNERS_LIST />,
  },
  {
    path: PATH.PARTNERS_NEW,
    key: PATH.PARTNERS_NEW,
    isProtected: true,
    page: <PARTNERS_NEW />,
  },
  {
    path: PATH.PARTNERS_DETAIL,
    key: PATH.PARTNERS_DETAIL,
    isProtected: true,
    page: <PARTNERS_DETAIL />,
  },
  {
    path: PATH.PARTNER_DASHBOARD,
    key: PATH.PARTNER_DASHBOARD,
    isProtected: true,
    page: <PARTNER_DASHBOARD />,
  },
  {
    path: PATH.PARTNER_MEMBERS,
    key: PATH.PARTNER_MEMBERS,
    isProtected: true,
    page: <PARTNER_MEMBERS />,
  },
  {
    path: PATH.PARTNER_CREDITS,
    key: PATH.PARTNER_CREDITS,
    isProtected: true,
    page: <PARTNER_CREDITS />,
  },
];
export default routes;
